/*
 * @FileName       : action.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/17/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : Action constants to store all the constants belongs to actions.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

export const REPORTS = {
	INVENTORY: {
		GROUP: {
			REQUEST: 'INVENTORY_GROUP',
			SUCCESS: 'INVENTORY_GROUP_RESPONSE',
			CLEAR_LIST: 'CLEAR_LIST',
			REPORT_FILTER: 'REPORT_FILTER',
			REPORT_FILTER_SUCCESS: 'REPORT_FILTER_SUCCESS',
		},
		HISTORY: {
			LIST: 'INVENTORY_HISTORY_LIST',
			LIST_RESPONSE: 'INVENTORY_HISTORY_LIST_RESPONSE',
		},
		CURRENT: {
			LIST: 'INVENTORY_CURRENT_LIST',
			LIST_RESPONSE: 'INVENTORY_CURRENT_LIST_RESPONSE',
			FIX_COLUMNS: 'FIX_COLUMNS',
			FIX_COLUMNS_SUCCESS: 'FIX_COLUMNS_SUCCESS',
		},
		USAGE: {
			LIST: 'INVENTORY_USAGE_LIST',
			LIST_RESPONSE: 'INVENTORY_USAGE_LIST_RESPONSE',
			CLEAR_USAGE_LIST: 'CLEAR_USAGE_LIST',
			EXPORT: 'TRANSACTION_LOG_EXPORT',
			GET_GROUP: 'GET_TRANSACTION_GROUP',
			SET_GROUP: 'SET_TRANSACTION_GROUP',
			SET_GROUP_NAMES: 'SET_GROUP_NAMES',
		},
	},
	DISPENSED: {
		GET: 'GET_DISPENSED_PRODUCTS_REPORT',
		SET: 'SET_DISPENSED_PRODUCTS_REPORT',
	},
	CYCLE_COUNTS: {
		GET: 'GET_CYCLE_COUNT_REPORT',
		SET: 'SET_CYCLE_COUNT_REPORT',
	},
	SHIPMENTS: {
		GET: 'GET_WAREHOUSE_SHIPMENTS_REPORT',
		SET: 'SET_WAREHOUSE_SHIPMENTS_REPORT',
	},
	CLEAR_GLOBAL_DATA: 'CLEAR_GLOBAL_DATA',
	RESTOCK_ORDER_DETAILS: {
		IG_SHIPMENT_ITEMS: 'IG_SHIPMENT_ITEMS',
		RESTOCK_REQUEST: 'RESTOCK_REQUEST',
		WAREHOUSE_SHIPMENT: 'WAREHOUSE_SHIPMENT',
		TRANSACTIONS: 'TRANSACTIONS',
		SAP_ORDERS: 'SAP_ORDERS',
	},
	SET_RESTOCK_ORDER_DETAILS: {
		IG_SHIPMENT_ITEMS: 'SET_IG_SHIPMENT_ITEMS',
		RESTOCK_REQUEST: 'SET_RESTOCK_REQUEST',
		WAREHOUSE_SHIPMENT: 'SET_WAREHOUSE_SHIPMENT',
		TRANSACTIONS: 'SET_TRANSACTIONS',
		SAP_ORDERS: 'SET_SAP_ORDERS',
	},
};

export const UI = {
	SET_CUSTOMER: 'SET_CUSTOMER',
	SET_SELECTED_DATE_RANGE: 'SET_SELECTED_DATE_RANGE',
	SET_SELECTED_CABINET_TYPE: 'SET_SELECTED_CABINET_TYPE',
	SET_SELECTED_EXPIRY_DATE: 'SET_SELECTED_EXPIRY_DATE',
	SET_SELECTED_HISTORY_DATE: 'SET_SELECTED_HISTORY_DATE',
	SET_SELECTED_TRANSMITTAL_DATE: 'SET_SELECTED_TRANSMITTAL_DATE',
	SET_MORE_FILTER_VALUE: 'SET_MORE_FILTER_VALUE',
	STORE_CUSTOMER: 'STORE_CUSTOMER',
	NAVIGATE: 'UI_NAVIGATE',
	NAVIGATE_RESPONSE: 'UI_NAVIGATE_RESPONSE',
	SHOW_LOADER: 'SHOW_LOADER',
	SET_INVENTORY_STATE: 'SET_INVENTORY_STATE',
	GET_INVENTORY_STATE: 'GET_INVENTORY_STATE',
	SET_API_ERROR: 'SET_API_ERROR',
	SET_NAV_DRAWER: 'SET_NAV_DRAWER',
	SET_URL_FILTER: 'SET_URL_FILTER',
	SET_NAV_STATE: 'SET_NAV_STATE',
	CLOUD_MGNT_LINK_LOADING: 'CLOUD_MGNT_LINK_LOADING',
	AUTH_PROCESSING: 'AUTH_PROCESSING',
	RESET_ALL_FILTERS: 'RESET_ALL_FILTERS',
	SET_GLOBAL_ROWS_PER_PAGE: 'SET_GLOBAL_ROWS_PER_PAGE',
	SET_SAVE_SEARCH_PAGE_NAME: 'SET_SAVE_SEARCH_PAGE_NAME',
	SET_SAVE_SEARCH_TITLE: 'SET_SAVE_SEARCH_TITLE',
	SET_SELECTED_SAVE_FILTER: 'SET_SELECTED_SAVE_FILTER',
	DISABLE_SERIAL_NUMBER_FILTER: 'DISABLE_SERIAL_NUMBER_FILTER',
	DISABLE_OWNERSHIP_FILTER: 'DISABLE_OWNERSHIP_FILTER',
};

export const CABINET = {
	LIST: 'GET_CABINETS_REQUEST',
	LIST_RESPONSE: 'GET_CABINETS_RESPONSE',
	TABLE_LIST: 'GET_CABINETS_TABLE_REQUEST',
	TABLE_LIST_RESPONSE: 'GET_CABINETS_TABLE_RESPONSE',
	CLEAR_CABINET_LIST: 'CLEAR_CABINET_LIST',
	INVENTORY: {
		LIST: 'GET_CABINET_INVENTORY_REQUEST',
		LIST_RESPONSE: 'GET_CABINET_INVENTORY_RESPONSE',
	},
	STATE: {
		LIST: 'LIST',
		LIST_RESPONSE: 'LIST_RESPONSE',
	},
	GET_CABINET_DETAILS_REQUEST: 'GET_CABINET_DETAILS_REQUEST',
	GET_CABINET_DETAILS_MBRX: 'GET_CABINET_DETAILS_MBRX',
	SET_CABINET_DETAILS: 'SET_CABINET_DETAILS',
	SET_CABINET: 'SET_CABINET',
	SET_DETAILS_ERROR: 'SET_DETAILS_ERROR',
	TEMPERATURE: {
		GET_TEMPERATURE: 'GET_TEMPERATURE',
		GET_TEMPERATURE_SUCCESS: 'GET_TEMPERATURE_SUCCESS',
		GET_TEMPERATURE_CSV: 'GET_TEMPERATURE_CSV',
		GET_ZONE_AVERAGE_TEMPERATURE: 'GET_ZONE_AVERAGE_TEMPERATURE',
		GET_ZONE_AVERAGE_TEMPERATURE_SUCCESS: 'GET_ZONE_AVERAGE_TEMPERATURE_SUCCESS',
		CLEAR_ZONE_AVERAGE_TEMPERATURE: 'CLEAR_ZONE_AVERAGE_TEMPERATURE',
	},
	GET_TELEMETRY_METRICS: 'GET_TELEMETRY_METRICS',
	SET_TELEMETRY_METRICS: 'SET_TELEMETRY_METRICS',
	GET_PRODUCTS: 'GET_PRODUCTS',
	SET_PRODUCTS: 'SET_PRODUCTS',
	UPDATE_PO_TYPE: 'UPDATE_PO_TYPE',
	UPDATE: 'UPDATE',
	GET_CABINET_USERS: 'GET_CABINET_USERS',
	SET_CABINET_USERS: 'SET_CABINET_USERS',
	GET_SINGLE_CABINET_USER: 'GET_SINGLE_CABINET_USER',
	SET_SINGLE_CABINET_USER: 'SET_SINGLE_CABINET_USER',
	GET_AVAILABLE_USERS: 'GET_AVAILABLE_USERS',
	SET_AVAILABLE_USERS: 'SET_AVAILABLE_USERS',
	ADD_CABINET_USER: 'ADD_CABINET_USER',
	UPDATE_CABINET_USER: 'UPDATE_CABINET_USER',
	CREATE_CABINET: 'CREATE_CABINET',
	CABINET_ERROR: 'CABINET_ERROR',
	ADD_PRODUCT: 'ADD_PRODUCT',
	GET_CABINET_PRODUCT_INVENTORY: 'GET_CABINET_PRODUCT_INVENTORY',
	SET_CABINET_PRODUCT_INVENTORY: 'SET_CABINET_PRODUCT_INVENTORY',
	GET_CYCLE_COUNT_INVENTORY: 'GET_CYCLE_COUNT_INVENTORY',
	SET_CYCLE_COUNT_INVENTORY: 'SET_CYCLE_COUNT_INVENTORY',
	SET_CYCLE_COUNT_INVENTORY_ERROR: 'SET_CYCLE_COUNT_INVENTORY_ERROR',
	UPDATE_CABINET_PRODUCT_INVENTORY: 'UPDATE_CABINET_PRODUCT_INVENTORY',
	REPORT_CABINET_INVENTORY: 'REPORT_CABINET_INVENTORY',
	REPORT_CABINET_INVENTORY_TWO: 'REPORT_CABINET_INVENTORY_TWO',
	GET_CONSIGNMENT_ORDERS: 'GET_CONSIGNMENT_ORDERS',
	SET_CONSIGNMENT_ORDERS: 'SET_CONSIGNMENT_ORDERS',
	GET_CABINET_LATEST_SCAN: 'GET_CABINET_LATEST_SCAN',
	SET_CABINET_LATEST_SCAN: 'SET_CABINET_LATEST_SCAN',
	GET_CABINET_CONNECTIVITY_GRAPH: 'GET_CABINET_CONNECTIVITY_GRAPH',
	SET_CABINET_CONNECTIVITY_GRAPH: 'SET_CABINET_CONNECTIVITY_GRAPH',
	GET_CABINET_LTEWIFI_GRAPH: 'GET_CABINET_LTEWIFI_GRAPH',
	SET_CABINET_LTEWIFI_GRAPH: 'SET_CABINET_LTEWIFI_GRAPH',
	GET_PROPERTY_LIST: 'GET_PROPERTY_LIST',
	SET_PROPERTY_LIST: 'SET_PROPERTY_LIST',
	GET_EDGE_CONFIG_PROPERTIES: 'GET_EDGE_CONFIG_PROPERTIES',
	SET_EDGE_CONFIG_PROPERTIES: 'SET_EDGE_CONFIG_PROPERTIES',
	UPDATE_EDGE_CONFIG_PROPERTIES: 'UPDATE_EDGE_CONFIG_PROPERTIES',
	GET_PROVIDER_BY_ID: 'GET_PROVIDER',
	SET_FOUND_PROVIDER: 'SET_FOUND_PROVIDER',
	ADD_CABINET_PROVIDER: 'ADD_CABINET_PROVIDER',
	DELETE_CABINET_PROVIDERS: 'DELETE_CABINET_PROVIDERS',
	ADD_CABINET_LOCATION_TRACKING: 'ADD_CABINET_LOCATION_TRACKING',
	DELETE_CABINET_LOCATION_TRACKING: 'DELETE_CABINET_LOCATION_TRACKING',
	GET_PROPERTIES_BY_CABINET_TYPE: 'GET_PROPERTIES_BY_CABINET_TYPE',
	SET_PROPERTIES_BY_CABINET_TYPE: 'SET_PROPERTIES_BY_CABINET_TYPE',
	SAVE_CABINET_PROPERTIES: 'SAVE_CABINET_PROPERTIES',
	DELETE_CABINET_PROPERTY: 'DELETE_CABINET_PROPERTY',
	SAVE_CABINET_PROPERTY_META: 'SET_CABINET_PROPERTY_META',
	SET_BACK_FROM_DETAILS: 'SET_BACK_FROM_DETAILS',
	SET_CABINET_CONFIG_ERROR: 'SET_CABIENT_CONFIG_ERROR',
	GET_CONTEXT_CABINETS: 'GET_CONTEXT_CABINETS',
	SET_CONTEXT_CABINETS: 'SET_CONTEXT_CABINETS',
	SET_CABINET_PRODUCT_PAR: 'SET_CABINET_PRODUCT_PAR',
	GET_FLEX_CONFIG: 'GET_FLEX_CONFIG',
	SET_FLEX_CONFIG: 'SET_FLEX_CONFIG',
	SET_FLEX_PRODUCT_LIST: 'SET_FLEX_PRODUCT_LIST',
	UPDATE_FLEX_CONFIG: 'UPDATE_FLEX_CONFIG',
	SEND_MANUAL_RECEIPT: 'SEND_MANUAL_RECEIPT',
	FLEX_RESET_DEFAULT: 'FLEX_RESET_DEFAULT',
	SEND_MANUAL_CORRECTION: 'SEND_MANUAL_CORRECTION',
	INVENTORY_SYNC: 'INVENTORY_SYNC',
	GET_DEVICE_TAGS: 'GET_DEVICE_TAGS',
	STORE_DEVICE_TAGS: 'STORE_DEVICE_TAGS',
	SET_DEVICE_TAGS: 'SET_DEVICE_TAGS',
	GET_CABINET_RECEIPTS: 'GET_CABINET_RECEIPTS',
	SET_CABINET_RECEIPTS: 'SET_CABINET_RECEIPTS',
	REJECT_CABINET_RECEIPT: 'REJECT_CABIENT_RECEIPT',
	GET_SECURE_DEVICE_COMPARTMENTS: 'GET_SECURE_DEVICE_COMPARTMENTS',
	GET_NEXT_CABINET_ID: 'GET_NEXT_CABINET_ID',
	SET_NEXT_CABINET_ID: 'SET_NEXT_CABINET_ID',
	IMPORT_DEVICE_SETTINGS: 'IMPORT_DEVICE_SETTINGS'
};

export const TENANTS = {
	LIST: 'GET_TENANTS_REQUEST',
	LIST_RESPONSE: 'GET_TENANTS_RESPONSE',
	CLEAR_TENANTS_LIST: 'CLEAR_TENANTS_LIST',
	GET_TENANT: 'GET_TENANT',
	SYNC: 'SYNC',
	UPDATE_TENANT: 'UPDATE_TENANT',
	GET_CREDIT_CARD_ELIGIBLE_PRODUCTS_FOR_CUSTOMER: 'GET_CREDIT_CARD_ELIGIBLE_PRODUCTS_FOR_CUSTOMER',
	SET_CREDIT_CARD_ELIGIBLE_PRODUCTS_FOR_CUSTOMER: 'SET_CREDIT_CARD_ELIGIBLE_PRODUCTS_FOR_CUSTOMER',
	GET_CLASS_OF_TRADE_OPTIONS: 'GET_CLASS_OF_TRADE_OPTIONS',
	SET_CLASS_OF_TRADE_OPTIONS: 'SET_CLASS_OF_TRADE_OPTIONS',
	GET_FACILITY_TYPE_OPTIONS: 'GET_FACILITY_TYPE_OPTIONS',
	SET_FACILITY_TYPE_OPTIONS: 'SET_FACILITY_TYPE_OPTIONS',
	DETAILS: {
		DETAIL_LIST: 'DETAIL_LIST',
		DETAIL_LIST_RESPONSE: 'DETAIL_LIST_RESPONSE',
		BASIC_INFO_REQUEST: 'BASIC_INFO_REQUEST',
		BASIC_INFO_RESPONSE: 'BASIC_INFO_RESPONSE',
		ADDITIONAL_INFO_REQUEST: 'ADDITIONAL_INFO_REQUEST',
		ADDITIONAL_INFO_RESPONSE: 'ADDITIONAL_INFO_RESPONSE',
		NOTIFICATION_ACTIVITY_REQUEST: 'NOTIFICATION_ACTIVITY_REQUEST',
		NOTIFICATION_ACTIVITY_RESPONSE: 'NOTIFICATION_ACTIVITY_RESPONSE',
		NOTIFICATION_MESSAGE_REQUEST: 'NOTIFICATION_MESSAGE_REQUEST',
		NOTIFICATION_MESSAGE_RESPONSE: 'NOTIFICATION_MESSAGE_RESPONSE',
		GET_PRODUCTS: 'GET_CUSTOMER_PRODUCTS',
		SET_PRODUCTS: 'SET_CUSTOMER_PRODUCTS',
		CREATE_CUSTOMER_PRODUCT: 'CREATE_CUSTOMER_PRODUCT',
	},
};

export const INVENTORY_MANAGEMENT = {
	LIST_PAR: 'GET_PAR_INVENTORY',
	LIST_PAR_RESPONSE: 'GET_PAR_INVENTORY_RESPONSE',
	LIST_PAR_GROUP_RESPONSE: 'GET_PAR_INVENTORY_GROUP_RESPONSE',
	SET_INVENTORY_FILTER: 'SET_INVENTORY_FILTER',
	SET_COMPLETE_INVENTORY: 'SET_COMPLETE_INVENTORY',
	CARTRIDGE_INVENTORY: 'GET_CARTRIDGE_INVENTORY',
	CARTRIDGE_INVENTORY_RESPONSE: 'GET_CARTRIDGE_INVENTORY_RESPONSE',
	GROUPED_CARTRIDGE_INVENTORY_RESPONSE: 'GROUPED_CARTRIDGE_INVENTORY_RESPONSE',
	SERIAL_INVENTORY: 'GET_SERIAL_INVENTORY',
	SERIAL_INVENTORY_RESPONSE: 'GET_SERIAL_INVENTORY_RESPONSE',
	GROUPED_SERIAL_INVENTORY_RESPONSE: 'GROUPED_SERIAL_INVENTORY_RESPONSE',
	LIST_INVENTORY: 'GET_VC_INVENTORY',
	LIST_INVENTORY_RESPONSE: 'GET_VC_INVENTORY_RESPONSE',
	GROUPED_INVENTORY_RESPONSE: 'GROUPED_INVENTORY_RESPONSE',
	SET_QUANTITY: 'SET_CABINET_INVENTORY_QUANTITY',
	UPDATE_RECEIPT: 'UPDATE_CABINET_INVENTORY_RECEIPT',
	GET_SUSPENDED_TRANSACTIONS: 'GET_SUSPENDED_TRANSACTIONS',
	SET_SUSPENDED_TRANSACTIONS: 'SET_SUSPENDED_TRANSACTIONS',
	UPDATE_SUSPENDED_TRANSACTIONS: 'UPDATE_SUSPENDED_TRANSACTIONS',
	ERROR: 'ERROR',
	CLEAR_TENANT_INVENTORY: 'CLEAR_TENANT_INVENTORY',
	INVENTORY_CSV: 'INVENTORY_CSV',
	GET_TAGS: 'GET_TAGS',
	SET_TAGS: 'SET_TAGS',
	GET_TAG_LIFECYCLE: 'GET_TAG_LIFECYCLE',
	SET_TAG_LIFECYCLE: 'SET_TAG_LIFECYCLE',
	UPDATE_PRODUCT_TAG_SERIALS: 'UPDATE_PRODUCT_TAG_SERIALS',
	FORCE_VEND: 'FORCE_VEND',
	REVERT_PRODUCT_TAG_SERIALS: 'REVERT_PRODUCT_TAG_SERIALS',
	RETURN_PRODUCT_TAG_SERIALS: 'RETURN_PRODUCT_TAG_SERIALS',
	SET_PRODUCT_OWNERSHIP: 'SET_PRODUCT_OWNERSHIP',
	GET_RESTOCK_RECOMMENDATIONS: 'GET_RESTOCK_RECOMMENDATIONS',
	SET_RESTOCK_RECOMMENDATIONS: 'SET_RESTOCK_RECOMMENDATIONS',
	BULK_UPDATE_PRODUCT_TAG_SERIALS: 'BULK_UPDATE_PRODUCT_TAG_SERIALS',
	BULK_FORCE_VEND: 'BULK_FORCE_VEND',
	BULK_REVERT_PRODUCT_TAG_SERIALS: 'BULK_REVERT_PRODUCT_TAG_SERIALS',
	BULK_RETURN_PRODUCT_TAG_SERIALS: 'BULK_RETURN_PRODUCT_TAG_SERIALS',
	BULK_SET_PRODUCT_OWNERSHIP: 'BULK_SET_PRODUCT_OWNERSHIP',
	REFRESH_PAR: 'REFRESH_PAR'
};

export const USER = {
	TOKEN: 'GET_FIREBASE_TOKEN',
	TOKEN_RESPONSE: 'GET_FIREBASE_TOKEN_RESPONSE',
	RECORD_REQUEST: 'GET_USER_RECORD_REQUEST',
	RECORD_RESPONSE: 'GET_USER_RECORD_RESPONSE',
	SET_NAV: 'SET_NAV',
	CLEAR_USER_STATE: 'CLEAR_USER_STATE',
	SEND_USER_SETUP: 'SEND_USER_SETUP',
	CREATE_USER_PROPERTY_REQUEST: 'CREATE_USER_PROPERTY_REQUEST',
	GET_USER_PROPERTY_REQUEST: 'GET_USER_PROPERTY_REQUEST',
	GET_USER_PROPERTY_RESPONSE: 'GET_USER_PROPERTY_RESPONSE',
	SET_PERSONAS: 'SET_PERSONAS',
	UPDATE_PERSONA_COMPLETE: 'UPDATE_PERSONA_COMPLETE',
	UPDATE_PERSONA_REQUEST: 'UPDATE_PERSONA_REQUEST',
	CREATE_PERSONA_REQUEST: 'CREATE_PERSONA_REQUEST',
	PERSONA_SAVE_COMPLETE: 'PERSONA_SAVE_COMPLETE',
	SET_USER_THEME: 'SET_USER_THEME',
	SET_SNACKBAR_OPEN: 'SET_SNACKBAR_OPEN',
	SET_SNACKBAR_MESSAGE: 'SET_SNACKBAR_MESSAGE',
	CREATE_REPORT_SUBSCRIPTION_REQUEST: 'CREATE_REPORT_SUBSCRIPTION_REQUEST',
	DELETE_REPORT_SUBSCRIPTION_REQUEST: 'DELETE_REPORT_SUBSCRIPTION_REQUEST',
	ADD_USER_SUBSCRIPTION_SUCCESS: 'ADD_USER_SUBSCRIPTION_SUCCESS',
	DELETE_USER_SUBSCRIPTION_SUCCESS: 'DELETE_USER_SUBSCRIPTION_SUCCESS',
	EDIT_REPORT_SUBSCRIPTION_REQUEST: 'EDIT_REPORT_SUBSCRIPTION_REQUEST',
	EDIT_USER_SUBSCRIPTION_SUCCESS: 'EDIT_USER_SUBSCRIPTION_SUCCESS',
	SET_CREATE_USER_ERROR: 'SET_CREATE_USER_ERROR',
	SEND_ONE_TIME_REPORT_REQUEST: 'SEND_ONE_TIME_REPORT_REQUEST',
	SEND_ONE_TIME_REPORT_SUCCESS: 'SEND_ONE_TIME_REPORT_SUCCESS',
	GET_USER_REPORT_QUEUE: 'GET_USER_REPORT_QUEUE',
	GET_USER_REPORT_QUEUE_SUCCESS: 'GET_USER_REPORT_QUEUE_SUCCESS',
	UPDATE_USER_QUEUE_ITEM: 'UPDATE_USER_QUEUE_ITEM',
	ADJUST_AWAITED_QUEUE_ITEMS_COUNT: 'ADJUST_AWAITED_QUEUE_ITEMS_COUNT',
	SET_USER_CABINETS: 'SET_USER_CABINETS',
	HANDLE_RNI_AUTH_TOKEN: 'HANDLE_RNI_AUTH_TOKEN',
	HANDLE_RNI_AUTH_PAGE_REFRESH: 'HANDLE_RNI_AUTH_PAGE_REFRESH',
};

export const USER_MANAGEMENT = {
	LIST_REQUEST: 'GET_USER_LIST_REQUEST',
	LIST_RESPONSE: 'GET_USER_LIST_RESPONSE',
	INVOICE_LINK_LIST_REQUEST: 'GET_INVOICE_LINK_USER_LIST_REQUEST',
	INVOICE_LINK_LIST_RESPONSE: 'GET_INVOICE_LINK_USER_LIST_RESPONSE',
	CREATE_INVOICE_LINK_USER: 'CREATE_INVOICE_LINK_USER',
	DELETE_INVOICE_LINK_USER: 'DELETE_INVOICE_LINK_USER',
	CREATE_REQUEST: 'CREATE_USER_REQUEST',
	UPDATE_REQUEST: 'UPDATE_USER_REQUEST',
	USER_EXISTS_REQUEST: 'USER_EXISTS_REQUEST',
	USER_EXISTS_RESPONSE: 'USER_EXISTS_RESPONSE',
	CLEAR_USER_CHECK: 'CLEAR_USER_CHECK',
	ERROR: 'USER_ERROR',
	IMPORT_USERS: 'IMPORT_USERS',
	SET_IMPORT_RESULT: 'SET_IMPORT_RESULT',
	RESET_USERS_DATA: 'RESET_USERS_DATA',
	GET_VIMEO_APP_AUTH_TOKEN: 'GET_VIMEO_APP_AUTH_TOKEN',
	SET_VIMEO_APP_AUTH_TOKEN_RESULT: 'SET_VIMEO_APP_AUTH_TOKEN_RESULT',
	SEND_SUPPORT_REQUEST: 'SEND_SUPPORT_REQUEST',
	SET_CREATE_USER_ERROR: 'SET_CREATE_USER_ERROR',
	SET_USER_IMPORT_SUCCESS: 'SET_USER_IMPORT_SUCCESS',
	GET_SINGLE_USER: 'GET_SINGLE_USER',
	SET_SINGLE_USER: 'SET_SINGLE_USER',
	RESEND_INVITE_EMAIL: 'RESEND_INVITE_EMAIL',
	SET_PASSWORD: 'SET_PASSWORD',
	DELETE_USER: 'DELETE_USER',
};

export const INVOICES = {
	LIST: 'GET_INVOICES_REQUEST',
	LIST_RESPONSE: 'GET_INVOICES_RESPONSE',
	OPEN_PAYMENT_PAGE: 'OPEN_PAYMENT_PAGE',
	PAYMENT_CONFIRMATION: 'PAYMENT_CONFIRMATION',
	SET_PAYMENT_CONFIRMED: 'SET_PAYMENT_CONFIRMED',
	CLEAR_INVOICES_LIST: 'CLEAR_INVOICES_LIST',
	GET_REQUESTS: 'GET_REQUESTS',
	SET_REQUESTS: 'SET_REQUESTS',
	PATCH_REQUEST_ABW: 'PATCH_REQUEST_ABW',
	PATCH_REQUEST_OMITTAL: 'PATCH_REQUEST_OMITTAL',
	PATCH_REQUEST_OMITTAL_BULK: 'PATCH_REQUEST_OMITTAL_BULK',
	SEND_ABW_REMINDER_EMAIL: 'SEND_ABW_REMINDER_EMAIL',
	TRANSMIT_REQUESTS_TO_SAP: 'TRANSMIT_REQUESTS_TO_SAP',
	UPDATE_INVOICE_STATUS: 'UPDATE_INVOICE_STATUS',
	PATCH_MAKE_ALL_INVOICES_READY: 'PATCH_MAKE_ALL_INVOICES_READY',
};

export const ALERTS = {
	LIST_REQUEST: 'GET_ALERT_LIST_REQUEST',
	LIST_RESPONSE: 'GET_ALERT_LIST_RESPONSE',
	GET_NOTIFICATION_TYPES: 'GET_NOTIFICATION_TYPES',
	SET_NOTIFICATION_TYPES: 'SET_NOTIFICATION_TYPES',
	GET_CHANNEL_TYPES: 'GET_CHANNEL_TYPES',
	SET_CHANNEL_TYPES: 'SET_CHANNEL_TYPES',
	GET_NOTIFICATION_CHANNEL_GROUPS: 'GET_NOTIFICATION_CHANNEL_GROUPS',
	SET_NOTIFICATION_CHANNEL_GROUPS: 'SET_NOTIFICATION_CHANNEL_GROUPS',
	SUBMIT_CHANNEL_GROUP: 'SUBMIT_CHANNEL_GROUP',
	DELETE_CHANNEL_GROUP: 'DELETE_CHANNEL_GROUP',
	GET_INCIDENTS: 'GET_INCIDENTS',
	SET_INCIDENTS: 'SET_INCIDENTS',
	GET_INCIDENT_HISTORY: 'GET_INCIDENT_HISTORY',
	SET_INCIDENT_HISTORY: 'SET_INCIDENT_HISTORY',
	GET_INCIDENT_RULES: 'GET_INCIDENT_RULES',
	SET_INCIDENT_RULES: 'SET_INCIDENT_RULES',
	UPDATE_INCIDENT: 'UPDATE_INCIDENT',
};

export const PRODUCTS = {
	LIST_REQUEST: 'GET_PRODUCT_LIST',
	LIST_RESPONSE: 'SET_PRODUCT_LIST',
	LIST_AUTOCOMPLETE_REQUEST: 'GET_AUTOCOMPLETE_PRODUCT_LIST',
	LIST_AUTOCOMPLETE: 'SET_AUTOCOMPLETE_PRODUCT_LIST',
	GET_ALL_PRODUCTS_LIST: 'GET_ALL_PRODUCTS_LIST',
	SET_ALL_PRODUCTS_LIST: 'SET_ALL_PRODUCTS_LIST',
	SAVE_NEW_PRODUCT: 'SAVE_NEW_PRODUCT',
	UPDATE_PRODUCT: 'UPDATE_PRODUCT',
	GET_PRODUCT_GROUPS: 'GET_PRODUCT_GROUPS',
	SET_PRODUCT_GROUPS: 'SET_PRODUCT_GROUPS',
};

export const ORDERS = {
	LIST_REQUEST: 'GET_ORDER_LIST',
	LIST_RESPONSE: 'SET_ORDER_LIST',
	GROUPED_LIST_REQUEST: 'GET_GROUPED_ORDER_LIST',
	GROUPED_LIST_RESPONSE: 'SET_GROUPED_ORDER_LIST',
	RESET_ORDERS: 'RESET_ORDERS',
	GET_SHIPMENTS: 'GET_SHIPMENTS',
	SET_SHIPMENTS: 'SET_SHIPMENTS',
	UPDATE_RESTOCK_ORDER_STATUS: 'UPDATE_RESTOCK_ORDER_STATUS',
	GET_RECOMMENDATIONS: 'GET_RECOMMENDATIONS',
	SET_RECOMMENDATIONS: 'SET_RECOMMENDATIONS',
	SET_RECOMMENDATIONS_TOTAL: 'SET_RECOMMENDATION_TOTAL',
	SET_INVENTORY_EXCEPTIONS_TOTAL: 'SET_INVENTORY_EXCEPTIONS_TOTAL',
	SET_ORDER_EXCLUSIONS: 'SET_ORDER_EXCLUSIONS',
	SYNC_ORDER_EXCLUSIONS: 'SYNC_ORDER_EXCLUSIONS',
	RELEASE_ORDERS: 'RELEASE_ORDERS',
	GET_CUSTOMER_PRODUCTS_FOR_ORDER: 'GET_CUSTOMER_PRODUCTS_FOR_ORDER',
	SET_CUSTOMER_PRODUCTS_FOR_ORDER: 'SET_CUSTOMER_PRODUCTS_FOR_ORDER',
	GET_PAR_RECORD: 'GET_PAR_RECORD',
	UPDATE_ORDER: 'UPDATE_ORDER',
	CHECK_JOB_STATUS: 'CHECK_JOB_STATUS',
	SYNC_WAREHOUSE_INVENTORY: 'SYNC_WAREHOUSE_INVENTORY',
	GET_ORDER_REQUESTS: 'GET_ORDER_REQUESTS',
	SET_ORDER_REQUESTS: 'SET_ORDER_REQUESTS',
	SUBMIT_ORDER_REQUEST: 'SUBMIT_ORDER_REQUEST',
	UPDATE_ORDER_REQUESTS: 'UPDATE_ORDER_REQUESTS',
	DELETE_ORDER_REQUEST: 'DELETE_ORDER_REQUEST'
};

export const AUDIT = {
	AUDIT_LOG_LIST_REQUEST: 'AUDIT_LOG_LIST_REQUEST',
	AUDIT_LOG_LIST_RESPONSE: 'AUDIT_LOG_LIST_RESPONSE',
	AUDIT_LOG_DETAILS_REQUEST: 'AUDIT_LOG_DETAILS_REQUEST',
	AUDIT_LOG_DETAILS_RESPONSE: 'AUDIT_LOG_DETAILS_RESPONSE',
	GET_EVENT_TYPES: 'GET_EVENT_TYPES',
	SET_EVENT_TYPES: 'SET_EVENT_TYPES',
};

export const SAVE_SEARCH_ACTIONS = {
	CREATE: {
		REQUEST_CREATE_SEARCH: 'REQUEST_CREATE_SEARCH',
		ERROR_CREATE_SEARCH: 'ERROR_CREATE_SEARCH',
	},
	UPDATE: {
		REQUEST_UPDATE_SEARCH: 'REQUEST_UPDATE_SEARCH',
		RESPONSE_UPDATE_SEARCH: 'RESPONSE_UPDATE_SEARCH',
	},
	LIST: {
		REQUEST_LIST_SEARCH: 'REQUEST_LIST_SEARCH',
		RESPONSE_LIST_SEARCH: 'RESPONSE_LIST_SEARCH',
	},
	SCHEDULE: {
		SCHEDULE_SAVE_REQUEST: 'SCHEDULE_SAVE_REQUEST',
	},
};

export const DASHBOARD = {
	GET_ALL_DASHBOARD_VALUES: 'GET_ALL_DASHBOARD_VALUES',
	SET_ALL_DASHBOARD_VALUES: 'SET_ALL_DASHBOARD_VALUES',
	DISMISS_ABW_REMINDERS: 'DISMISS_ABW_REMINDERS',
	DISMISS_CYCLE_COUNT_REMINDERS: 'DISMISS_CYCLE_COUNT_REMINDERS',
};
